export default {
  selectedStorePageId: '',

  storePageList: [],
};



// WEBPACK FOOTER //
// ./src/app/store-pages/store/state.js